import FranchisesService from 'src/services/franchises'

export default {
  fetchAll (payload) {
    this.status = 'loading'
    if (payload?.isOnAdmin) this.franchises = []

    const promise = FranchisesService.fetchAll(payload)

    promise.then(data => {
      this.franchises = data.data
      this.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        total_pages: data.last_page
      }
      this.status = 'success'
    })
      .catch(error => {
        console.error(error)
        this.status = 'error'
      })

    return promise
  },
  remove (franchise_id) {
    this.franchises = this.franchises.filter(franchise => franchise.id !== franchise_id)
  },
  fetchFranchises () {
    this.status = 'loading'
    const promise = FranchisesService.fetchFranchises()

    promise.then(data => {
      this.franchises = data
      this.status = 'success'
    })
      .catch(() => {
        this.status = 'error'
      })

    return promise
  }
}
